import { InjectionToken } from '@angular/core';
import { PostLoginProcessor } from './post-login-processor.interface';
import { UserSession } from './authentication.interfaces';
import { Observable } from 'rxjs';

export const POST_LOGOUT_PROCESSOR: InjectionToken<PostLoginProcessor> = new InjectionToken('POST_LOGOUT_PROCESSOR');

export interface PostLogoutProcessor {
	execute(userSession: UserSession): Observable<UserSession>;
}
